import EmailTemplateTable from 'components/Tables/EmailTemplateTable/EmailTemplateTable'
import React from 'react'

function ListEmailTemplate() {
  return (
    <div>
        <EmailTemplateTable/>
    </div>
  )
}

export default ListEmailTemplate
